import { render, staticRenderFns } from "./PoolNumbers.vue?vue&type=template&id=c138a0be&"
import script from "./PoolNumbers.vue?vue&type=script&lang=ts&"
export * from "./PoolNumbers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports